import { Vue, Component, Prop } from 'vue-property-decorator';
import { isMicroStandardId, getTaxonomyTags } from '@/utils/utils';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import TaxonomyCard from '../taxonomy-card/taxonomy-card';
import { appConfigService } from '@/providers/services/app/app-config';

@Component({
    name: 'lesson-card',
    components: {
        'material-icon': GoogleMaterialIcon,
        'taxonomy-card': TaxonomyCard,
    },
})

export default class ResourceCard extends Vue {

    // ------------------------------------------------------------------
    // Properties
    @Prop()
    private resource: any;

    @Prop({ default: false })
    private isMyContent!: boolean;

    private get tags() {
        return this.resource.standards;
    }

    // ----------------------------------------------------------------------------
    // Actions
    private onPlayResource(resourceId: string) {
        const playerURL = `${window.location.origin}/library/content/resources/play/${resourceId}?source=rgo`;
        this.$emit('onOpenPlayer', playerURL);
    }

    private openPullout() {
        this.$emit('openPullout', this.resource);
    }

    private editResource(resourceId: string) {
        const currentRoute = this.$router.currentRoute.path;
        const playerURL = `${window.location.origin}/library/content/resources/edit/${resourceId}?redirectUrl=${currentRoute}`;
        window.location.href = playerURL;
    }

    private filterCreator(creator: any) {
        this.$emit('filterCreator', creator);
    }
}
